import { ModalSlideUpComponent } from './modal-slide-up.component';

export default angular
  .module('sfMobile.components.modal-slide-up', [])
  .component('sfModalSlideUp', ModalSlideUpComponent).name;
